export default __webpack_public_path__ + "static/circle-e-ferry-228760bb3deed5ea536c28559744ae7c.png";